<template>
  <layout-navigation>
    <search />
  </layout-navigation>
</template>
<script>
  import LayoutNavigation from '@/layouts/navigation.vue';
  import Search from './search.vue';

  export default {
    components: {
      LayoutNavigation,
      Search,
    },
  };
</script>
